<template>
  <div>
    <header-applis titre="Connaître votre projet" sous-titre="Vous êtes une personne en recherche d’emploi" index-progression-courante="1"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Si vous êtes inscrit comme demandeur d’emploi, vous pouvez prendre contact avec votre conseiller Pôle emploi pour échanger à propos de votre projet.</p>
          <ul>
            <li>Si vous n’êtes pas à Pôle emploi, identifiez et contactez votre Conseiller en Évolution Professionnelle (CEP) pour échanger à propos de votre projet : <a
                href="//www.mon-cep.org" target="_blank">www.mon-cep.org</a></li>
          </ul>
        </li>
        <li>
          <p>Une fois votre orientation finalisée, nous vous invitons à reprendre la démarche engagée, nous pourrons alors donner suite à votre demande.</p>
        </li>
      </ul>
      <envoyer-recapitulatif/>
    </div>
    <footer-applis ecran-precedent="choixstatut"/>
  </div>
</template>

<script>
import EnvoyerRecapitulatif from '../../components/EnvoyerRecapitulatif';
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'rechercheemploi',
  components: {
    FooterApplis,
    HeaderApplis,
    EnvoyerRecapitulatif
  }
}
</script>
